export default __webpack_public_path__ + "static/media/menu.a902396f.svg";